<div class="top-bar">
  <div class="top-bar-main cp-left"></div>

  <div class="logo">
    <a [routerLink]="['/']">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 210 32" data-v-b4ba0d97="">
        <path d="M52.377 6.996H10.383L13.357 0h41.978l-2.958 6.996ZM47.166 19.235H5.188l2.973-6.997H50.14l-2.973 6.997ZM41.978 31.492H0l2.974-6.996h41.978l-2.974 6.996ZM207.041 6.996h-41.994L168.021 0h41.993l-2.973 6.996ZM201.83 19.235h-41.994l2.974-6.997h41.978l-2.958 6.997ZM196.627 31.492h-41.994l2.974-6.996h41.978l-2.958 6.996ZM57.901 24.495 68.294 0h-7.685L47.242 31.491H89.22l2.974-6.996H57.901ZM102.169 31.491h-7.7L107.835 0h7.701l-13.367 31.491ZM120.763 0l-2.958 6.996h34.277l-10.393 24.495h7.701L162.757 0h-41.994Z"></path>
      </svg>
    </a>
  </div>

  <div class="top-bar-main">
    <div class="user-box dropdown is-right" [class]="{'is-active': isMenuActive}" #menu> 

      <div class="user-box-content dropdown-trigger">
        <span class="lang-img"  (click)="languageClicked()">{{ lang() }}</span>
        @if (userId() !== 0 && !noImg()) {
        <img class="user-img" id="user-img" style="margin-right: 20px;" (click)="profileClicked()" [src]="imgUrl()" (error)="updateUrl()" />
        }
        @if (userId() == 0 || noImg()) {
        <img class="user-img" style="margin-right: 20px;" (click)="profileClicked()" src="/assets/img/user_placeholder.png" />
        }
        <div class="user-data">
          {{ firstName() }} {{ lastName() }}
          <br>
          @if (userEmail !== undefined) {
          <span class="user-id">{{ userEmail() }}</span>
          }
        </div>
      </div>

      <div class="dropdown-menu" id="dropdown-menu" role="menu">
        <div class="dropdown-content">
          @if (userId() == 0 && !lang_click) {
          <a class="dropdown-item" (click)="loginClicked()">
            {{ 'menu_login' | translate }}
          </a>
          <a class="dropdown-item" (click)="registerClicked()">
            {{ 'menu_register' | translate }}
          </a>
          }
          @if (userId() !== 0 && !lang_click) {
          <a class="dropdown-item" (click)="logoutClicked()">
            {{ 'menu_logout' | translate }}
          </a>
          }
          @if (lang_click) {
          <a class="dropdown-item" (click)="langClicked('en')">
            {{ 'lang_en' | translate }}
          </a>
          <a class="dropdown-item" (click)="langClicked('it')">
            {{ 'lang_it' | translate }}
          </a>
          }
        </div>
      </div>
        
    </div>
  </div>
</div>
